<!--时间间隔选择-->
<template>
	<div class="checkbox">
		<div><img :src="getImg(1)" @click="nowValue = '1'"/><span>是</span></div>
		<div><img :src="getImg(0)"  @click="nowValue = '0' "/><span>否</span></div>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {},
		props: {
			defaultValue: {
				type: String
			},
			disable: {
				type: Boolean,
				default: () => {
					return false
				}
			},
		},
		data() {
			return {
				nowValue: 1
			}
		},
		created() {},
		mounted() {
			if (this.defaultValue != undefined) {
				this.nowValue = this.defaultValue
			}
		},
		destroyed() {},
		computed: {
			getImg() {
				return i => {
					if (this.nowValue == i) {
						return resourcesStore.getters.getResourcesByName("checkBox/checked.png")
					}
					return resourcesStore.getters.getResourcesByName("checkBox/unchecked.png")
				}
			}
		},
		watch: {
			nowValue(nv,ov){
				this.$emit("checkItem", nv)
			}
		},
		methods: {
		}
	}
</script>

<style scoped>
	.checkbox {
		display: inline-flex;
		justify-content: center;
		align-items: center;
	}

	.checkbox>div {
		align-items: center;
		display: flex;
		justify-content: center;
		font-size: .12rem;
		cursor: pointer;
		padding: .05rem .15rem;
		margin-left: .2rem;
	}

	.checkbox img {
		width: .15rem;
		margin-right: .05rem;
		height: .15rem;
	}
</style>
